(() => {
  // The section may be inserted multiple times or reloaded by the theme editor.
  if (window.bunkerCatasMotionInitialized) return;
  window.bunkerCatasMotionInitialized = true;

  const katarsisPath = '/pages/katarsis';
  const publishKatarsisEvent = (name, placement) => {
    try {
      if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return false;
      const result = window.Shopify.analytics.publish(name, {
        page_path: katarsisPath,
        placement
      });
      if (result && typeof result.catch === 'function') result.catch(() => {});
      return true;
    } catch (_error) {
      // Analytics must never interfere with the link or the contact form.
      return false;
    }
  };

  const isWhatsAppLink = (anchor) => {
    try {
      const hostname = new URL(anchor.href, window.location.href).hostname.toLowerCase();
      return hostname === 'wa.me' || hostname.endsWith('.wa.me') ||
        hostname === 'whatsapp.com' || hostname.endsWith('.whatsapp.com');
    } catch (_error) {
      return false;
    }
  };

  document.addEventListener('click', (event) => {
    if (window.location.pathname !== katarsisPath) return;
    const target = event.target instanceof Element ? event.target : event.target && event.target.parentElement;
    const anchor = target && target.closest('a[href]');
    if (!anchor) return;

    if (anchor.matches('[data-katarsis-whatsapp="form"]')) {
      publishKatarsisEvent('bunker_katarsis_whatsapp_form_click', 'contact_form');
      return;
    }

    if (isWhatsAppLink(anchor)) {
      publishKatarsisEvent('bunker_katarsis_whatsapp_floating_click', 'floating');
    }
  });

  const publishFormSuccess = (root) => {
    if (window.location.pathname !== katarsisPath) return;
    root.querySelectorAll('[data-katarsis-form-success]').forEach((success) => {
      if (success.dataset.katarsisAnalyticsSent) return;
      if (publishKatarsisEvent('bunker_katarsis_form_success', 'contact_form')) {
        success.dataset.katarsisAnalyticsSent = 'true';
      }
    });
  };
  publishFormSuccess(document);

  const selector = '.catas-tasting, .catas-info';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pending = new Set();
  const completed = new WeakSet();
  let observer;

  const reveal = (section) => {
    section.classList.add('catas-motion-visible');
    completed.add(section);
    pending.delete(section);
    if (observer) observer.unobserve(section);
  };

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting === true && entry.intersectionRatio >= 0.2 && pending.has(entry.target)) {
          reveal(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px' });
  }

  const initialize = (root) => {
    const sections = [...root.querySelectorAll(selector)];
    if (root.matches && root.matches(selector)) sections.unshift(root);
    sections.forEach((section) => {
      if (completed.has(section) || pending.has(section)) return;
      if (!observer || reducedMotion.matches) {
        completed.add(section);
        return;
      }
      section.querySelectorAll('.catas-tasting__item, .catas-info__row').forEach((item, index) => {
        item.style.setProperty('--catas-motion-order', index);
      });
      section.classList.add('catas-motion-ready');
      pending.add(section);
      observer.observe(section);
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
    publishFormSuccess(event.target);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    pending.forEach((section) => {
      if (event.target.contains(section)) {
        observer.unobserve(section);
        pending.delete(section);
      }
    });
  });
  reducedMotion.addEventListener('change', (event) => {
    if (event.matches) {
      pending.forEach(reveal);
      document.querySelectorAll(selector).forEach((section) => {
        section.classList.remove('catas-motion-ready');
      });
    }
  });
})();
